"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
interface TechnicalQuoteCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  primaryLabel: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, TechnicalQuoteCopy> = {
  en: {
    eyebrow: "ASTM E2016 Inspection & Verification",
    heading: "Request a Technical Quote for ASTM E2016 Wire Mesh",
    lead: "Provide mesh specifications, alloy requirements, or custom fabrication dimensions. Our engineering team delivers prompt technical evaluation and quotation.",
    primaryLabel: "Request a Quote",
    secondaryLabel: "Contact Engineering"
  },
  zh: {
    eyebrow: "ASTM E2016 检验与技术规范",
    heading: "索取符合 ASTM E2016 标准的丝网技术报价",
    lead: "请提供目数规格、合金材质要求或定制加工尺寸。我们的工程技术团队将迅速提供参数核算与技术报价。",
    primaryLabel: "索取报价",
    secondaryLabel: "联系工程团队"
  },
  es: {
    eyebrow: "Inspección y verificación ASTM E2016",
    heading: "Solicite una cotización técnica para malla metálica ASTM E2016",
    lead: "Indique las especificaciones de malla, aleación o dimensiones de fabricación a medida para recibir una evaluación técnica y cotización.",
    primaryLabel: "Solicitar presupuesto",
    secondaryLabel: "Contactar ingeniería"
  },
  de: {
    eyebrow: "ASTM E2016 Prüfung & Spezifikation",
    heading: "Technisches Angebot für Drahtgewebe nach ASTM E2016 anfordern",
    lead: "Geben Sie Maschenweite, Legierungsanforderungen oder Abmessungen für Sonderanfertigungen an. Unser Engineering-Team prüft Ihre Daten und erstellt ein Angebot.",
    primaryLabel: "Angebot anfragen",
    secondaryLabel: "Engineering kontaktieren"
  },
  fr: {
    eyebrow: "Contrôle et spécification ASTM E2016",
    heading: "Demander un devis technique pour toile métallique ASTM E2016",
    lead: "Indiquez les spécifications de maille, le choix d'alliage ou les dimensions de découpe sur mesure. Notre équipe technique évalue vos besoins et vous répond rapidement.",
    primaryLabel: "Demander un devis",
    secondaryLabel: "Contacter l'ingénierie"
  },
  pt: {
    eyebrow: "Inspeção e conformidade ASTM E2016",
    heading: "Solicitar cotação técnica para malha metálica ASTM E2016",
    lead: "Informe as especificações de malha, requisitos de liga ou dimensões para fabricação personalizada. Nossa equipe técnica fornece avaliação rápida e cotação.",
    primaryLabel: "Solicitar orçamento",
    secondaryLabel: "Falar com engenharia"
  }
};
export default function TechnicalQuote() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="technicalquotecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: content.primaryLabel,
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} />;
}